<div class="spinner" *ngIf="spinnerService.showSpinner$ | async">
  <mat-spinner></mat-spinner>
</div>
<router-outlet></router-outlet>
